<template>
  <v-fade-transition hide-on-leave>
    <v-skeleton-loader v-if="!loaded" class="mx-auto" width="90%" type="card" />
    <GmapMap
      v-else
      :center="centerLocation"
      :zoom="zoomLevel"
      map-type-id="roadmap"
      ref="map"
      style="width: 90%; height: 450px"
    >
      <GmapMarker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        @click="center = m.position"
      />
    </GmapMap>
  </v-fade-transition>
</template>

<script>
import { getGoogleMapsAPI } from "gmap-vue";

export default {
  data() {
    return {
      markers: [],
      zoomLevel: 16,
      empresaLocaton: { lat: 0, lng: 0 },
      loaded: false,
    };
  },
  computed: {
    google: getGoogleMapsAPI,
    centerLocation: function () {
      return this.empresaLocaton;
    },
  },
  props: {
    value: null,
  },
  methods: {
    async findEmpresaLocation() {
      const service = new this.google.maps.places.PlacesService(document.createElement("div"));

      const request = {
        query: this.$props.value,
        fields: ["formatted_address", "geometry.location"],
      };

      service.findPlaceFromQuery(request, (results, status) => {
        if (status === self.google.maps.places.PlacesServiceStatus.OK) {
          this.loaded = true;
          this.empresaLocaton = results[0].geometry.location;
          this.markers.push({
            position: results[0].geometry.location,
          });
        }
      });
    },
  },
  async mounted() {
    await this.$gmapApiPromiseLazy();
    this.findEmpresaLocation();
  },
};
</script>

<style scoped>
#map {
  grid-area: map;
  width: 90%;
  height: 400px;
  padding: 25px;
  margin: 25px auto;
}
.nav {
  text-align: center;
}
</style>